export default __webpack_public_path__ + "static/flop-app-logo-dark-ae0dabeea90f7fef63997b3aa47c260b.png";